'use client'

import React from 'react'
import type { Header } from '@/payload-types'
import { Label } from '@/components/ui/label'
import { Sheet, SheetTrigger, SheetContent } from '@/components/ui/sheet'
import { Button } from '@/components/ui/Button'
import { NavigationMenuItem, NavigationMenuLink } from './navigation-menu'
import { NavigationMenuList } from './navigation-menu'
import { NavigationMenu } from './navigation-menu'
import { NavLink } from './NavLink'
import { getCMSLinkHrefAndTabProps } from '@/utilities/getCMSLinkHref'
import { usePathname } from 'next/navigation'
import { isLinkActive } from './utils'
import { ListItem } from './ListItem'
import { ScrollArea } from '@/components/ui/scroll-area'

interface Props {
  data: Header
}

export function MobileNav({ data }: Props) {
  const pathname = usePathname()
  const [open, setOpen] = React.useState(false)

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button
          variant="ghost"
          size="clear"
          className="hover:scale-110 transition-all duration-100 hover:text-punch"
        >
          <BarsIcon className="w-6 h-6" />
        </Button>
      </SheetTrigger>
      <SheetContent>
        <ScrollArea className="h-screen">
          <NavigationMenu className="flex flex-col items-start px-[10px] pt-[10px] pb-[50px]">
            <NavigationMenuList className="flex flex-col items-start gap-[10px]">
              {data.sections?.map((section) => {
                return (
                  <>
                    <Label className="pt-[20px] pl-[10px] text-body-lg">{section.title}</Label>
                    {section.items?.map((item) => (
                      <NavigationMenuItem key={item.id} className="w-full">
                        <ListItem
                          className="block w-full"
                          key={item.id}
                          icon={item.icon ?? ''}
                          title={item.link.label}
                          onClick={() => setOpen(false)}
                          {...getCMSLinkHrefAndTabProps(item.link)}
                        >
                          {item.description}
                        </ListItem>
                      </NavigationMenuItem>
                    ))}
                  </>
                )
              })}
              {data.links?.map((link) => {
                const props = getCMSLinkHrefAndTabProps(link.link)
                return (
                  <NavigationMenuItem key={link.id}>
                    <NavigationMenuLink asChild>
                      <NavLink
                        {...props}
                        className="underline"
                        active={isLinkActive(pathname, link)}
                        onClick={() => setOpen(false)}
                      />
                    </NavigationMenuLink>
                  </NavigationMenuItem>
                )
              })}
              <NavigationMenuItem>
                <NavLink
                  {...getCMSLinkHrefAndTabProps({
                    label: 'Discord',
                    type: 'custom',
                    url: 'https://sia.tech/discord',
                    newTab: true,
                  })}
                  className="underline"
                  onClick={() => setOpen(false)}
                />
              </NavigationMenuItem>
              <NavigationMenuItem>
                <NavLink
                  {...getCMSLinkHrefAndTabProps({
                    label: 'GitHub',
                    type: 'custom',
                    url: 'https://github.com/siafoundation',
                    newTab: true,
                  })}
                  className="underline"
                  onClick={() => setOpen(false)}
                />
              </NavigationMenuItem>
            </NavigationMenuList>
          </NavigationMenu>
        </ScrollArea>
      </SheetContent>
    </Sheet>
  )
}

function BarsIcon({ className }: { className: string }) {
  return (
    <svg
      id="Bars"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={className}
      fill="currentColor"
    >
      <polygon points="22 11 23 11 23 13 22 13 22 14 2 14 2 13 1 13 1 11 2 11 2 10 22 10 22 11" />
      <polygon points="22 19 23 19 23 21 22 21 22 22 2 22 2 21 1 21 1 19 2 19 2 18 22 18 22 19" />
      <polygon points="23 3 23 5 22 5 22 6 2 6 2 5 1 5 1 3 2 3 2 2 22 2 22 3 23 3" />
    </svg>
  )
}
